import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Swedish Personnummer validator following Single Responsibility Principle
 */
export class PersonnummerValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Swedish Personnummer',
      pattern: /^\d{6}-?\d{4}$/,
      length: 10
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Personnummer format must be YYMMDD-XXXX or YYMMDDXXXX'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Luhn algorithm
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      let digit = parseInt(cleanId[i]);
      
      if (i % 2 === 1) {
        digit *= 2;
        if (digit > 9) {
          digit = Math.floor(digit / 10) + (digit % 10);
        }
      }
      
      sum += digit;
    }

    const expectedChecksum = (10 - (sum % 10)) % 10;
    const actualChecksum = parseInt(cleanId[9]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid Personnummer checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Personnummer');
  }
}